import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { X } from "lucide-react";
 * // Use <X /> instead
 */
export const CloseIcon = createSVGWrapper(
  <path
    fill="currentColor"
    d="M18.364 5.636a1 1 0 0 0-1.414 0L12 10.586l-4.95-4.95A1 1 0 0 0 5.636 7.05l4.95 4.95-4.95 4.95a1 1 0 0 0 1.414 1.414l4.95-4.95 4.95 4.95a1 1 0 0 0 1.414-1.414L13.414 12l4.95-4.95a1 1 0 0 0 0-1.414Z"
  />
);
